import React, { useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import logoSrc from 'shared/img/logo.svg'

import { selectLocaleDict } from 'features/locale/selectors'

import Button from 'components/UIKit/Button/Button'

import './NotifyContainer.scss'

interface INotifyContainerProps {
  title: string
  value: number
  currency: string
  callback: () => void
  backgroundCallback: () => void
}

const b = block('notify-container')

const NotifyContainer: React.FC<INotifyContainerProps> = ({ title, value, callback, backgroundCallback, currency }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  return (
    <div className={b()}>
      <div className={b('background')} onClick={backgroundCallback} />
      <div className={b('container')}>
        <div className={b('heading')}>
          <span className={b('title')}>{title}</span>
        </div>
        <div className={b('content')}>
          <div className={b('you-got')}>{locale.youGot}</div>
          <div className={b('value-wrapper')}>
            <div className={b('value')}>{value}</div>
            <div className={b('currency')}>{currency}</div>
          </div>
          <div className={b('button-wrapper')}>
            <Button text={locale.ok} onClick={callback} uppercase fullWidth />
          </div>
        </div>
        <div className={b('logo-wrapper')}>
          <img src={logoSrc} alt="Setebets" className={b('logo')} />
          <div className={b('ellipse')} />
        </div>
      </div>
    </div>
  )
}

export default NotifyContainer
